"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Youtube;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Youtube(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("title", null, "YouTube"), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Social_media",
    "data-name": "Social media"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "youtube",
    d: "M88.328,30.676a10.055,10.055,0,0,0-7.073-7.119C75.017,21.875,50,21.875,50,21.875s-25.017,0-31.256,1.682a10.054,10.054,0,0,0-7.072,7.119C10,36.956,10,50.057,10,50.057s0,13.1,1.672,19.38a9.9,9.9,0,0,0,7.072,7.006C24.983,78.125,50,78.125,50,78.125s25.016,0,31.255-1.682a9.9,9.9,0,0,0,7.073-7.006C90,63.158,90,50.057,90,50.057S90,36.956,88.328,30.676ZM41.818,61.952V38.162l20.909,11.9Z"
  })));
}